<template>
  <v-card id="content-card" :tile="wgFullscreen" :width="width2" :height="height2" :class="[{'py-5 px-4': !wgFullscreen}]" style="margin: 0px auto">
      <slot/>
  </v-card>
</template>

<script>
import widgetMixin from '@/mixins/widgetMixin'

export default {
    mixins: [widgetMixin],
    props: {
        width: {
            type: [Number, String],
            default: 800,
            require: false
        },
        height: {
            type: [Number, String],
            default: 640,
            require: false
        }
    },

    computed: {
        width2() {
            return this.wgFullscreen ? '100vw' : this.width
        },
        height2() {
            return this.wgFullscreen ? '100%' : 'auto'
        }
    },

    mounted() {
        this.postMessage('dialog:open')
    }
}
</script>

<style>

</style>